import type {
  CoachingSessionType,
  ParticipationReport,
} from '@efdigital/ll-addon-data';
import type { CoachPostAttendanceMarkRequestBody } from '@efdigital/ll-cdk-coaching-sessions-api-types';

export function scheduledDurationMinutes(session: {
  startTime: Date | string;
  endTime: Date | string;
}): number {
  const startMs =
    session.startTime instanceof Date
      ? session.startTime.getTime()
      : Date.parse(session.startTime);
  const endMs =
    session.endTime instanceof Date
      ? session.endTime.getTime()
      : Date.parse(session.endTime);
  const minutes = Math.floor((endMs - startMs) / 60_000);
  if (!Number.isFinite(minutes) || minutes <= 0) {
    throw new Error('Invalid session duration');
  }
  return minutes;
}

export function confirmedDurationOptions(
  scheduledMinutes: number,
  maxMinutes = scheduledMinutes + 120
): number[] {
  const options: number[] = [];
  for (let minutes = scheduledMinutes; minutes <= maxMinutes; minutes += 15) {
    options.push(minutes);
  }
  return options;
}

export function buildCoachAttendanceMarkBody(input: {
  report: ParticipationReport;
  sessionType: CoachingSessionType;
  issueDetails?: string;
  confirmedDurationMinutes?: number | null;
}): CoachPostAttendanceMarkRequestBody {
  return {
    report: input.report,
    ...(input.report === 'reported_issue'
      ? { issueDetails: input.issueDetails?.trim() }
      : {}),
    ...(input.report === 'session_delivered' &&
    input.sessionType === 'coaching' &&
    input.confirmedDurationMinutes != null
      ? { confirmedDurationMinutes: input.confirmedDurationMinutes }
      : {}),
  };
}
